import Leaderboard from "../components/Leaderboard";

export default function LeaderboardPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <Leaderboard />
    </div>
  );
}